<template>
  <span>{{childrenCount}}</span>
</template>

<script>
export default {
    name: 'ProjectChildrenCount',

    props: ['parentId'],

    data() {
        return {
            childrenCount: -1
        };
    },

    watch: {
        parentId() {
            this.countByParentId();
        }
    },

    methods: {
        countByParentId() {
            if(!this.parentId) {
                return;
            }

            var _this = this;
            sdk.ProjectApi().countByParentId({
                parentId: _this.parentId
            }).then(res => {
                _this.childrenCount = res;
            });
        }
    },

    mounted() {
        this.countByParentId();
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/ProjectChildrenCount.vue